export const UX_CONSTANTS = {
  SEARCH_VISIBILITY_THRESHOLD: 0,
};
